export default "__VITE_ASSET__366b9685__"